const CACHE_KEY_PREFIX = "replies_cache:";

export const readCache = (commentId) => {
  try {
    const raw = localStorage.getItem(`${CACHE_KEY_PREFIX}${commentId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeCache = (commentId, replies) => {
  try {
    localStorage.setItem(`${CACHE_KEY_PREFIX}${commentId}`, JSON.stringify(replies));
  } catch {}
};

export const clearRepliesCache = () => {
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(CACHE_KEY_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch {}
};
